interface PendingReviewData {
  clinicId: string
  clinicSlug: string
  rating: number
  comment?: string
  pros?: string
  cons?: string
  savedAt: number
}

const STORAGE_KEY = 'pending_review'
const TTL_MS = 24 * 60 * 60 * 1000 // 24 hours

export function usePendingReview() {
  function save(data: Omit<PendingReviewData, 'savedAt'>) {
    const entry: PendingReviewData = { ...data, savedAt: Date.now() }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entry))
  }

  function get(): PendingReviewData | null {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    try {
      const data = JSON.parse(raw) as PendingReviewData
      if (Date.now() - data.savedAt > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY)
        return null
      }
      return data
    } catch {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
  }

  function clear() {
    localStorage.removeItem(STORAGE_KEY)
  }

  function hasPendingForClinic(clinicId: string): boolean {
    const data = get()
    return data?.clinicId === clinicId
  }

  return { save, get, clear, hasPendingForClinic }
}
